import { render, staticRenderFns } from "./CVProfileImgUpload.vue?vue&type=template&id=4ccb2d98"
import script from "./CVProfileImgUpload.vue?vue&type=script&lang=js"
export * from "./CVProfileImgUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports